import {FC} from "react";
import {Text} from "../../ui-components/text.tsx";
import AddUserIconGreen from "../../assets/images/userFilled.svg";
import Voka from "../../assets/images/voka.svg";
import {Switch, SwitchField} from "../../ui-components/switch.tsx";
import {formatNumber, getEngagementRate} from "../../utils/Utils.ts";
import {IChannelResponseData} from "../../state/models/ChannelResponse.ts";
import {ICategoriesResponseData} from "../../state/models/CategoriesResponse.ts";

export const AvailableChannelCard: FC<{
    data: IChannelResponseData,
    categoriesData: ICategoriesResponseData[],
    toggleCheckBox: (id: string) => void
}> = ({data, categoriesData, toggleCheckBox}) => {

    const toggleCheckBoxHandler = () => {
        toggleCheckBox(data.id)
    }

    const selectedCategories = (categoriesData && data.categories) ? categoriesData.filter(category =>
        data.categories.includes(category.id)
    ).map(i => i.title).join(', ') : '-';

    const engagementRate = getEngagementRate(data.average_views,  data.subscribers_count)

    return (
        <section className={'w-full flex justify-between items-center px-3 py-3 gap-2 bg-white rounded-xl cursor-pointer'}
                 onClick={toggleCheckBoxHandler}>
            <div className={"flex"}>
                <SwitchField className="grid grid-cols-[max-content] mr-3 h-[40px]">
                    <Switch color={"dark/zinc"}
                            checked={data.isChecked}
                            onChange={toggleCheckBoxHandler}
                            onClick={(e) => e.stopPropagation()}
                            className="!w-[38px] !h-[22px] sm:!w-[35px] !p-[2px] !col-start-1  bg-[var(--background-switcher)] data-checked:border-transparent border border-[var(--btn-border-custom)] [&>span]:!w-[16px] [&>span]:!h-[16px]">
                    </Switch>
                </SwitchField>
                <div className={"rounded-md"}>
                    <img src={data.profile_image_url} className={"object-fill max-w-10 max-h-10 rounded-md"}
                         alt={"l"}></img>
                </div>
                <div className={"flex flex-col gap-1 ml-3 "}>
                    <Text className={"!text-xs leading-3 !text-black font-medium break-all"}>{data.telegram_channel_name}</Text>
                    <div className={"flex gap-1 max-w-[100%]"}>
                        <span className={"text-[10px] text-[var(--color-secondary)]"}>{selectedCategories}</span>
                    </div>
                </div>
            </div>
            <div className={"flex flex-col gap-1 items-start min-w-[85px]"}>
                <div
                    className={`flex items-center gap-1 justify-center flex-nowrap whitespace-nowrap`}>
                    <AddUserIconGreen/>
                    <Text className={"!text-xs text-[var(--color-secondary)]"}>
                        {data.subscribers_count && formatNumber(data.subscribers_count)}
                    </Text>
                </div>
                <div
                    className={`flex items-center gap-1 justify-center flex-nowrap`}>
                    <Voka/>
                    <Text className={"!text-xs text-[var(--color-secondary)] whitespace-nowrap"}>
                        {data.average_views && formatNumber(data.average_views)} ({engagementRate}%)
                    </Text>
                </div>
            </div>
        </section>
    )
}